import type { GetStaticProps, NextPage } from "next";
import FaqView from "@components/views/FaqView";
import Head from "next/head";

const FaqPage: NextPage = () => {
	return (
		<>
			<Head>
				<title>Часто задаваемые вопросы — Selfschool</title>
				<meta
					name="description"
					content="Мы собрали часто задаваемые вопросы о платформе Selfschool и ответили на них. Здесь вы найдете правила платформы, информацию о создании курсов, ответы на вопросы о финансах и многое другое."
				/>
			</Head>
			<FaqView />
		</>
	);
};

export const getStaticProps: GetStaticProps = async () => {
	return {
		props: {},
	};
};

export default FaqPage;
